/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { ALL_ROUTES, API_CONSTANTS, APP_CONSTANTS } from "../../global/Constants";
import "./sign-in.css";
import ApiServices from "../../providers/ApiServices";
import Utilities from "../../global/Utilities";
import Loader from "../common/loader/Loader";
import AuthService from '../../providers/AuthService';
import { CryptoService } from "../../providers/CryptoService";

class SignInPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            setPasswordShown: false,
            errorMsg: "",
            fields: {
                email: "",
                password: "",
            },
        };
    }

    componentDidMount() {
        // document.addEventListener('contextmenu', (e) => {
        //     e.preventDefault();
        // });

        let path = this.props.location.pathname;
        if (!path.includes("admin")) {
            let token = localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN);
            if (token) {
                if (token.length !== 0) {
                    this.props.history.push(ALL_ROUTES.HOME_TODAY_ROUTE);
                }
            }
            document.getElementById("login").disabled = true;
        } else {
            this.props.history.push(path);
        }

        Utilities.LogPrint("Navigator", navigator.userAgent);
    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({ fields });
        const email = this._getFieldValue("email", "");
        const password = this._getFieldValue("password", "");
        document.getElementById("login").disabled = email === "" || password === "";
    };

    resetValue = () => {
        document.getElementById('pass').value = "";
        // let fields = this.state.fields;
        // fields['password'] = "";
        // this.setState({ fields });
    }

    _performLogin = () => {
        this.setState({ loading: true });
        const { email, password } = this.state.fields;

        var body = JSON.stringify({
            userId: email,
            password: CryptoService.encryptPassword(password),
            isLoginOtp: false,
        });

        try {
            ApiServices.logIn(body)
                .then(response => {
                    this.setState({ loading: false });
                    var status = response.success;
                    if (status) {
                        //localStorage.setItem(API_CONSTANTS.ACCESS_TOKEN, "Bearer " + response.data.token);

                        //TODO 
                        //AuthService.setSession(APP_CONSTANTS.APP_USER, response.data);
                        //this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);

                        if (response.data?.token) {
                            this.props.history.push({
                                pathname: ALL_ROUTES.VERIFY_OTP,
                                state: { email: email, token: response?.data?.token }
                            })
                        } else {
                            AuthService.setSession(APP_CONSTANTS.APP_USER, response.data);
                            this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
                        }

                    } else {
                        Utilities.LogPrint("Status", response.message);
                        this.resetValue();
                        if (response.message !== undefined && response.message) {
                            this.setState({
                                errorMsg: response.message
                            });
                        }
                    }
                }).catch(error => {
                    this.setState({ loading: false, errorMsg: error });
                });
        } catch (error) {
            this.setState({ loading: false, errorMsg: error });
        }
    }

    _handleSignIn = (e) => {
        e.preventDefault();
        const email = this._getFieldValue("email", "");
        const password = this._getFieldValue("password", "");

        var numberPattern = new RegExp(/^[0-9\b]+$/);
        var emailPattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (!numberPattern.test(email)) {
            if (!emailPattern.test(email)) {
                this.setState({
                    errorMsg: "Enter Valid Email"
                });
            } else {
                this._performLogin();
            }
        } else if (email.length !== 10) {
            this.setState({
                errorMsg: "Enter Valid Mobile"
            });
        } else if (password.length < 6 && password.length < 19) {
            this.setState({
                errorMsg: "Password must be 8 to 20 character"
            });
        }
        else {
            this.setState({
                errorMsg: ""
            });
            this._performLogin();
        }
    };

    _handleForgotPassword = () => {
        this.props.history.push(ALL_ROUTES.FORGOT_PASSWORD_ROUTE);
    };

    _handleLoginWithOtp = () => {
        this.props.history.push(ALL_ROUTES.LOGIN_WITH_OTP_ROUTE);
    };

    _togglePasswordVisibility = () => {
        this.setState({ setPasswordShown: !this.state.setPasswordShown });
    };

    render() {
        const { setPasswordShown, errorMsg, loading } = this.state;
        const email = this._getFieldValue("email", "");
        //const password = this._getFieldValue("password", "");

        return (
            <div className="sign-page input-dh">
                <div className="row mx-auto">
                    <div className="col-md-6 col-12 homeimg pr-5">
                        <img
                            src="../assets/images/login-side-image.jpg"
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                    <div className="col-md-6 col-12 pl-md-0 pr-md-5">
                        <div className="row">
                            <div className="col-12 signin-max-489">
                                <div className="logo">
                                    <img
                                        src="../assets/images/logo.png"
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>

                                <h5>Welcome</h5>
                                <form action="">
                                    <div className="form-group">
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Mobile / Email"
                                            onChange={this._handleValueChange.bind(this, "email")}
                                            value={email}
                                        />
                                    </div>
                                    <div className="form-group pass-hide-show">
                                        <input
                                            id="pass"
                                            type={setPasswordShown ? "text" : "password"}
                                            className="form-control"
                                            placeholder="Password"
                                            minLength={6}
                                            maxLength={20}
                                            onChange={this._handleValueChange.bind(this, "password")}
                                        //value={password}
                                        />
                                        <i
                                            className={
                                                setPasswordShown
                                                    ? "customic ic-eye"
                                                    : "customic ic-eye-hide"
                                            }
                                            onClick={this._togglePasswordVisibility}>
                                        </i>
                                        <span
                                            className={
                                                errorMsg.length > 0 ? "error-msg" : "d-none error-msg"
                                            }
                                        >
                                            {errorMsg}
                                        </span>
                                    </div>
                                    <div className="form-group">
                                        <a
                                            onClick={this._handleForgotPassword}
                                        >
                                            Forgot Password?
                                        </a>
                                    </div>

                                    <button
                                        className="btn btn-primary w-100 mb-2"
                                        id="login"
                                        onClick={this._handleSignIn}
                                    >
                                        LOGIN
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary mt-2 mt-md-3 w-100"
                                        onClick={this._handleLoginWithOtp}
                                    >
                                        LOGIN WITH OTP
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {loading ? <Loader /> : null}
            </div>
        );
    }
}

export default withRouter(SignInPage);
